import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import { useTranslation } from "react-i18next";
// icons
import { milesAndMoreIcon } from "../../../common/vector";
// helpers
import { MILES_AND_MORE_NUMBER_LENGTH } from "../helpers/airlineLandingHelpers";

interface MilesAndMoreBannerProps {
  showInput: boolean;
  milesAndMoreNumber: string;
  onMilesAndMoreChange: (value: string) => void;
  disableEditInput: boolean;
}

export default function MilesAndMoreBanner({
  showInput,
  milesAndMoreNumber,
  onMilesAndMoreChange,
  disableEditInput
}: MilesAndMoreBannerProps) {
  const { t } = useTranslation();

  const handleChange = (value: string) => {
    onMilesAndMoreChange(value.replace(/\D/g, "").slice(0, MILES_AND_MORE_NUMBER_LENGTH));
  };

  if (!showInput) {
    return (
      <Box className="miles-and-more-banner" sx={{ py: { xs: 1, sm: 4 }, px: { xs: 1, sm: 8 } }}>
        <img src={milesAndMoreIcon.default} alt="no-img-placeholder" style={{ height: "50px", width: "100%" }} />
        <Box sx={{ fontSize: "18px", whiteSpace: "pre-line", mt: { xs: 2, sm: 3 }, mb: { xs: 0, sm: 3 } }}>
          {t("airline.milesAndMore.description")}
        </Box>
      </Box>
    );
  }

  return (
    <Box className="miles-and-more-banner">
      <Box
        sx={{
          fontSize: "17px",
          color: "text.primary",
          textAlign: "left",
          mb: 1,
          fontFamily: "Neutraface2Demi"
        }}
      >
        {t("airline.milesAndMore.inputLabel")}
      </Box>
      <TextField
        disabled={disableEditInput}
        fullWidth
        value={milesAndMoreNumber}
        onChange={event => handleChange(event.target.value)}
        placeholder={t("airline.milesAndMore.inputPlaceholder")}
        variant="outlined"
        InputLabelProps={{ shrink: false }}
        inputProps={{
          "data-cy": "airline-miles-and-more",
          inputMode: "numeric"
        }}
        sx={{
          "& .MuiInputBase-root": {
            height: 59,
            paddingLeft: "12px",
            backgroundColor: "#fff"
          },
          "& .MuiInputBase-input": {
            height: "28px",
            display: "flex",
            alignItems: "center"
          },
          // Browsers can apply their own "autofill" background (often blue/yellow) when they think
          // this field is a saved credential/profile value. Override it for consistent styling.
          "& .MuiInputBase-input:-webkit-autofill, & .MuiInputBase-input:-webkit-autofill:hover, & .MuiInputBase-input:-webkit-autofill:focus, & .MuiInputBase-input:-webkit-autofill:active":
            {
              WebkitBoxShadow: "0 0 0 1000px #fff inset",
              boxShadow: "0 0 0 1000px #fff inset",
              WebkitTextFillColor: "inherit",
              caretColor: "inherit"
            },
          "& .MuiInputBase-input:-moz-autofill": {
            boxShadow: "0 0 0 1000px #fff inset"
          },
          "& .MuiInputBase-input::placeholder": {
            color: "black"
          }
        }}
      />
    </Box>
  );
}
